import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { GlobalMessageService, GlobalMessageType, RoutingService } from '@spartacus/core';
import { iAddUpdateRequestBody, UserManagementService } from './user-management.service';

@Component({
  selector: 'app-user-management',
  templateUrl: './user-management.component.html',
  styleUrls: ['./user-management.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserManagementComponent implements OnInit {

  isAddUserFlag: boolean = false;
  isExistingUser: boolean = false;
  isExistingUserWithValue: boolean = false;
  isInValidFormData: boolean = true;
  userData: any;
  userDetails: any;
  isUserExist: boolean = false;
  isUserSuccess: boolean = false;
  isSpinnerLoading: boolean = false;
  form: FormGroup = this.userManagement.user;
  constructor(
    protected userManagement: UserManagementService,
    protected cd: ChangeDetectorRef,
    public globalMessageService: GlobalMessageService,
    public routingService: RoutingService,
  ) {
  }

  ngOnInit(): void {
    this.form.valueChanges.subscribe(value => {
      if (this.form.valid && value?.email && value?.email !== '' && value?.first_name && value?.first_name !== '' && value?.last_name && value?.last_name !== '' && value?.salutation && value?.salutation !== '' && value?.role !== '') {
        this.isInValidFormData = false;
      } else {
        this.isInValidFormData = true;
      }
    })
    this.getUsersList();

  }

  addUserBtnOnClick() {
    this.isAddUserFlag = true;
    this.clearAllValidations();
    this.form.reset();
  }

  onCloseAddUser() {
    this.isAddUserFlag = false;
    this.clearAllValidations();
  }

  clearAllValidations() {
    this.isExistingUser = false;
    this.isUserExist = false;
    this.isUserSuccess = false;
    this.isExistingUserWithValue = false;
  }

  openUserDetails({ uid }: any) {
    this.isUserExist = false;
    this.isUserSuccess = false;
    this.isExistingUserWithValue = false;
    this.userManagement.getUserDetails(uid).subscribe(data => {
      this.userDetails = data;
      let role = this.getRoleType(this.userDetails?.roles);
      this.form.patchValue({
        salutation: this.userDetails?.title,
        first_name: this.userDetails?.firstName,
        last_name: this.userDetails?.lastName,
        email: this.userDetails?.uid,
        role: role === 'Admin' ? 'Admin' : role === 'Buyer' ? 'Buyer' : 'Claims',
      });
      this.isAddUserFlag = true;
      this.isExistingUser = true;
    });
  }

  editUser() {
    this.isExistingUser = false;
    this.isExistingUserWithValue = true;
    this.isInValidFormData = false;

  }

  getRoleType(roles: string[]): string {
    return roles.length > 0 ? (roles.includes('b2badmingroup') ? 'Admin' : roles.includes('b2bclaimraisergroup') ? 'Buyer + Raise Claims' : 'Buyer') : '';
  }

  addOrUpdateUser() {
    this.isSpinnerLoading = true;
    let redirect = false;
    let request: iAddUpdateRequestBody = {
      email: this.form.get('email')?.value,
      firstName: this.form.get('first_name')?.value,
      lastName: this.form.get('last_name')?.value,
      isUpdateUser: this.isExistingUserWithValue ? true : false,
      titleCode: this.form.get('salutation')?.value,
      userType: this.form.get('role')?.value === 'Admin' ? 'ADMIN' : (this.form.get('role')?.value === 'Claims' ? 'CLAIMRAISER' : 'BUYER')

    }
    if (this.form.get('role')?.value !== 'Admin' && this.isExistingUserWithValue) {
      redirect = true;
    }
    this.userManagement.addOrUpdateUser(request).subscribe(
      data => {
        this.isSpinnerLoading = false;
        this.isUserExist = false;
        this.isUserSuccess = true;
        this.getUsersList();
        this.globalMessageService.remove(GlobalMessageType.MSG_TYPE_INFO);
        this.globalMessageService.add(
          this.isExistingUserWithValue ? "User has been succesfully updated" : "User has been successfully created",
          GlobalMessageType.MSG_TYPE_INFO,
          this.isExistingUserWithValue ? 6000 : 600000000
        );
        this.onCloseAddUser();
        if (redirect) {
          console.log('redirect');
          this.routingService.go({
            cxRoute: 'home',
          });
        }
      },
      error => {
        this.isSpinnerLoading = false;
        this.isUserExist = error?.error?.errors[0]?.message === 'Customer already exists' ? true : false;
        this.cd.detectChanges();
      }
    )
  }

  getUsersList() {
    this.userManagement.getUserList().subscribe(data => {
      this.userData = data?.users;
      this.cd.detectChanges();
    });
  }

}
